import { createElement as h } from 'react'

// Structural subset of buildFacts() output (card 2).
export type ProductFactsData = {
  summary?: Partial<Record<'composition' | 'weight' | 'pieces' | 'serves' | 'perPerson' | 'delivery', string | number | null>> | null
  faq?: { question: string; answer: string }[] | null
}

const fields = [
  ['composition', 'Состав'], ['weight', 'Вес'], ['pieces', 'Количество'],
  ['serves', 'На сколько персон'], ['perPerson', 'Цена за персону'],
  ['delivery', 'Заказ и доставка'],
] as const
const hasText = (value: unknown) =>
  (typeof value === 'string' && value.trim().length > 0) ||
  (typeof value === 'number' && Number.isFinite(value))

// Service values of the serves generator are not for buyers.
const serviceLabels = ['Не применимо', 'Требует уточнения']

export function ServesLabel({ label }: { label: string | null }) {
  return hasText(label) && !serviceLabels.includes(label!.trim()) ? h('p', {
    className: 'mf-serves-label px-1 lg:px-0 mb-1 text-xs md:text-sm leading-snug text-bodyGrey whitespace-normal break-words',
  }, label) : null
}

export function ProductFacts({ facts }: { facts?: ProductFactsData | null }) {
  const summary = fields.filter(([key]) => hasText(facts?.summary?.[key]))
  const pairs = facts?.faq
  const faq = (Array.isArray(pairs) ? pairs : [])
    .filter((pair) => hasText(pair?.question) && hasText(pair?.answer))
  if (!summary.length && !faq.length) return null
  return h('section', {
    className: 'mf-product-facts mt-4 text-xs md:text-sm leading-snug whitespace-normal break-words',
    'aria-label': 'Кратко о товаре',
  },
    h('h2', { className: 'font-semibold mb-2' }, 'Кратко'),
    summary.length ? h('dl', { className: 'mf-product-summary space-y-2' },
      ...summary.map(([key, title]) => h('div', { key },
        h('dt', { className: 'font-semibold' }, title),
        h('dd', null, facts!.summary![key])
      ))
    ) : null,
    faq.length ? h('div', { className: 'mf-product-faq mt-4 space-y-2' },
      h('h3', { className: 'font-semibold' }, 'Вопросы о товаре'),
      ...faq.map(({ question, answer }, index) => h('div', { key: index },
        h('h4', { className: 'font-semibold' }, question),
        h('p', null, answer)
      ))
    ) : null
  )
}
